
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_20173_133013)"}},[_c('path',{attrs:{"d":"M15.149 3.103c1.149 0 2.083.933 2.083 2.083v10.417c0 1.15-.934 2.083-2.083 2.083H4.732a2.084 2.084 0 01-2.083-2.083V5.186c0-1.15.933-2.083 2.083-2.083H15.15zm-8.333 6.25a1.04 1.04 0 00-1.042 1.042v3.125a1.04 1.04 0 102.083 0v-3.125a1.04 1.04 0 00-1.041-1.042zm2.083 4.167a1.04 1.04 0 102.083 0V7.27a1.04 1.04 0 10-2.083 0v6.25zm4.167-2.084a1.04 1.04 0 00-1.042 1.042v1.042a1.04 1.04 0 102.083 0v-1.042a1.04 1.04 0 00-1.041-1.042z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_20173_133013"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2.649 2.061)","d":"M0 0h14.583v16.667H0z"}})])])])
          )
        }
      }
    